import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";

/* eslint-disable @typescript-eslint/no-shadow */
import * as definitions from '../../definitions/reviews';
import reviewService from '../../services/review';
import { createAction } from '../../interfaces';
import { getErrorMessageFromErrorResponse, handleErrorResponse } from '../../utils/error';
export var reviewActionCreators = {
  createReviewRequest: function createReviewRequest() {
    return createAction(definitions.CREATE_REVIEW_REQUEST);
  },
  createReviewSuccess: function createReviewSuccess(review) {
    return createAction(definitions.CREATE_REVIEW_SUCCESS, review);
  },
  createReviewFail: function createReviewFail(error) {
    return createAction(definitions.CREATE_REVIEW_FAIL, error);
  },
  getReviewRequest: function getReviewRequest() {
    return createAction(definitions.GET_REVIEW_REQUEST);
  },
  getReviewSuccess: function getReviewSuccess(reviews) {
    return createAction(definitions.GET_REVIEW_SUCCESS, reviews);
  },
  getReviewFail: function getReviewFail(error) {
    return createAction(definitions.GET_REVIEW_FAIL, error);
  },
  getServiceReviewsRequest: function getServiceReviewsRequest() {
    return createAction(definitions.GET_SERVICE_REVIEWS_REQUEST);
  },
  getServiceReviewsSuccess: function getServiceReviewsSuccess(payload) {
    return createAction(definitions.GET_SERVICE_REVIEWS_SUCCESS, payload);
  },
  getServiceReviewsFail: function getServiceReviewsFail(error) {
    return createAction(definitions.GET_SERVICE_REVIEWS_FAIL, error);
  },
  updateReviewRequest: function updateReviewRequest() {
    return createAction(definitions.UPDATE_REVIEW_REQUEST);
  },
  updateReviewSuccess: function updateReviewSuccess(payload) {
    return createAction(definitions.UPDATE_REVIEW_SUCCESS, payload);
  },
  updateReviewFail: function updateReviewFail(error) {
    return createAction(definitions.UPDATE_REVIEW_FAIL, error);
  },
  clearReviewErrors: function clearReviewErrors() {
    return createAction(definitions.CLEAR_REVIEW_ERRORS);
  },
  clearReviewInfo: function clearReviewInfo() {
    return createAction(definitions.CLEAR_REVIEW_INFO);
  }
};
export var createReview = function createReview(dto) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var createReviewRequest, createReviewSuccess, createReviewFail;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              createReviewRequest = reviewActionCreators.createReviewRequest, createReviewSuccess = reviewActionCreators.createReviewSuccess, createReviewFail = reviewActionCreators.createReviewFail;
              dispatch(createReviewRequest());
              return _context.abrupt("return", reviewService.createReview(dto).then(function (review) {
                dispatch(createReviewSuccess(review));
              })["catch"](function (error) {
                dispatch(createReviewFail(error));
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getResourceReviews = function getResourceReviews(sessionId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var getReviewRequest, getReviewSuccess, getReviewFail;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              getReviewRequest = reviewActionCreators.getReviewRequest, getReviewSuccess = reviewActionCreators.getReviewSuccess, getReviewFail = reviewActionCreators.getReviewFail;
              dispatch(getReviewRequest());
              return _context2.abrupt("return", reviewService.getResourceReviewByUser(sessionId).then(function (reviews) {
                dispatch(getReviewSuccess(reviews));
              })["catch"](function (error) {
                dispatch(getReviewFail(error));
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var getServiceReviews = function getServiceReviews(serviceId) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var getServiceReviewsRequest, getServiceReviewsSuccess, getServiceReviewsFail;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              getServiceReviewsRequest = reviewActionCreators.getServiceReviewsRequest, getServiceReviewsSuccess = reviewActionCreators.getServiceReviewsSuccess, getServiceReviewsFail = reviewActionCreators.getServiceReviewsFail;
              dispatch(getServiceReviewsRequest());
              return _context3.abrupt("return", reviewService.getServiceReviews(serviceId).then(function (reviews) {
                dispatch(getServiceReviewsSuccess({
                  serviceId: serviceId,
                  reviews: reviews
                }));
              })["catch"](function (error) {
                dispatch(getServiceReviewsFail(error));
              }));

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var getAllServiceReviews = function getAllServiceReviews(serviceId) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var getServiceReviewsRequest, getServiceReviewsSuccess, getServiceReviewsFail;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              getServiceReviewsRequest = reviewActionCreators.getServiceReviewsRequest, getServiceReviewsSuccess = reviewActionCreators.getServiceReviewsSuccess, getServiceReviewsFail = reviewActionCreators.getServiceReviewsFail;
              dispatch(getServiceReviewsRequest());
              return _context4.abrupt("return", reviewService.getAllReviewsByService(serviceId).then(function (reviews) {
                dispatch(getServiceReviewsSuccess({
                  serviceId: serviceId,
                  reviews: reviews
                }));
              })["catch"](function (error) {
                dispatch(getServiceReviewsFail(error));
              }));

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var clearReviewErrors = function clearReviewErrors() {
  return function (dispatch) {
    var clearReviewErrorsAction = reviewActionCreators.clearReviewErrors;
    dispatch(clearReviewErrorsAction());
  };
};
export var clearReviewInfo = function clearReviewInfo() {
  return function (dispatch) {
    var clearReviewInfoAction = reviewActionCreators.clearReviewInfo;
    dispatch(clearReviewInfoAction());
  };
};
export var updateReview = function updateReview(dto) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch) {
      var updateReviewRequest, updateReviewSuccess, updateReviewFail, serviceId;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              updateReviewRequest = reviewActionCreators.updateReviewRequest, updateReviewSuccess = reviewActionCreators.updateReviewSuccess, updateReviewFail = reviewActionCreators.updateReviewFail;
              dispatch(updateReviewRequest());
              serviceId = dto.service.id;
              return _context5.abrupt("return", reviewService.updateReview(dto).then(function (review) {
                dispatch(updateReviewSuccess({
                  serviceId: serviceId,
                  review: review
                }));
              })["catch"](function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(updateReviewFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var setCurrentReview = function setCurrentReview(review) {
  return function (dispatch) {
    var getReviewSuccess = reviewActionCreators.getReviewSuccess;
    dispatch(getReviewSuccess(review));
  };
};